import { Module } from 'vuex'
import { ShipmentsStoreState } from '@/modules/shipments-module/store/shipments-store.model'
import { RootStoreState } from '@/store/root/root-store.model'
import { ShipmentsGridType } from '@/modules/shipments-module/components/grid/datasources/shipments-grid-datasource-factory'
import { UIComponentCustomFilterResponse } from '@/api/services/common/ui-component/custom-filter/ui-component-custom-filter.dto'
import {
    initialShipmentsSelectedOption,
    ShipmentsCustomFilter
} from '@/modules/shipments-module/components/sidebar/shipments-sidebar.model'
import { VtStore } from '@/store/vt-store'
import { StrictNullable } from '@/shared/types/app.types'
import { findNodeParentByPropertyValue } from '@/components/sideBar/sideBarUtils'
import { shipmentsSidebarOptions } from '@/modules/shipments-module/components/sidebar/shipments-sidebar-options'

const initialShipmentsStore =
    (): ShipmentsStoreState => ({
        // sidebar
        selectedOption: initialShipmentsSelectedOption,
        summaries: {},
        // grid
        filterModel: {},
        gridType: ShipmentsGridType.PENDING_TO_SENT
    })

const module: Module<ShipmentsStoreState, RootStoreState> = {
    namespaced: true,
    state: initialShipmentsStore,
    getters: {
        selectedOption:
            (state): ShipmentsStoreState['selectedOption'] => state.selectedOption,
        selectedParentOption:
            (state): StrictNullable<any> =>
                findNodeParentByPropertyValue('id', state.selectedOption?.id, shipmentsSidebarOptions().expanded),
        summaries:
            (state): ShipmentsStoreState['summaries'] => state.summaries,
        gridType:
            (state): ShipmentsStoreState['gridType'] => state.gridType,
        filterModel:
            (state): ShipmentsStoreState['filterModel'] => state.filterModel
    },
    mutations: {
        updateSelectedOption:
            (state, payload: ShipmentsStoreState['selectedOption']): void => {
                state.selectedOption = payload
            },
        updateSummaries:
            (state, payload: ShipmentsStoreState['summaries']): void => {
                state.summaries = payload
            },
        updateGridType:
            (state, payload: ShipmentsStoreState['gridType']): void => {
                state.gridType = payload
            },
        updateFilterModel:
            (state, payload: ShipmentsStoreState['filterModel']): void => {
                state.filterModel = payload
            }
    },
    actions: {
        resetState:
            ({ state }): void => {
                Object.assign(state, initialShipmentsStore())
            },
        setSelectedOption:
            ({ commit, getters }, payload: ShipmentsStoreState['selectedOption']): void => {
                if (payload?.hasOwnProperty('filterName')) {
                    // selected option is a custom filter
                    const customFilter: UIComponentCustomFilterResponse<ShipmentsCustomFilter> = payload
                    commit('updateSelectedOption', { ...customFilter, label: customFilter.filterName })
                    commit('updateGridType', customFilter.filterCriteria.gridType)
                    commit('updateFilterModel', customFilter.filterCriteria.filterModel)
                } else {
                    const { filterModel } = initialShipmentsStore()
                    commit('updateSelectedOption', payload)
                    const gridType = getters['selectedOption']?.data?.gridType ?? getters['selectedParentOption']?.data?.gridType
                    commit('updateGridType', gridType)
                    commit('updateFilterModel', payload?.filterModel ?? filterModel)
                }
            }
    }
}
export const shipmentsStore = new VtStore<ShipmentsStoreState>('shipments', module)
